module.exports = __webpack_public_path__ + "img/wfil-bbg.5e592ee6.svg";